import { render, staticRenderFns } from "./yiXinApplicationPreview.vue?vue&type=template&id=09bfe9b8"
import script from "./yiXinApplicationPreview.vue?vue&type=script&lang=js"
export * from "./yiXinApplicationPreview.vue?vue&type=script&lang=js"
import style0 from "./yiXinApplicationPreview.vue?vue&type=style&index=0&id=09bfe9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports